import { render, staticRenderFns } from "./KanbanBoardTaskListLineMeta.vue?vue&type=template&id=ed344fcc"
import script from "./KanbanBoardTaskListLineMeta.vue?vue&type=script&lang=js"
export * from "./KanbanBoardTaskListLineMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports